export const PAGINATION = {
  PAGE_NUMBER: "pageNumber",
  ROW_PER_PAGE: "rowsPerPage",
  TOTAL: "total",
  TOTAL_FORM_SEARCH: "totalFromSearch",
};
